<template>
  <div class="container">
    <div class="containerSerch">
      <a-select show-search allowClear placeholder="公司名称" class="margin_self" v-model="form.companyId"
        :filter-option="filterOption" style="width: 180px">
        <a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-input v-model="form.categoryName" allowClear class="a_input_self margin_self" placeholder="品类名称" />
      <a-button type="primary" @click="searchData">查询</a-button>
      <a-button type="primary" @click="reset"> 重置 </a-button>
      <a-button type="primary" @click="addCaterage">新增品类</a-button>
      <a-button type="primary" @click="exp"> 数据导出 </a-button>
    </div>
    <div class="content_main_center" id="content_main_center_scroll2" style="margin-top:0">
      <a-table :columns="columns" :data-source="categoryList" bordered :loading="show" :pagination="false"
        :scroll="{ y: scroll_y }">
        <span slot="index" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="edit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="details(record)">详情</a>
        </span>
      </a-table>
      <div class="pageBottom">
        <a-pagination v-model="pagination.current" show-size-changer :page-size.sync="pagination.pageSize"
          :total="pagination.totalCount" @showSizeChange="onShowSizeChange" :pageSizeOptions="['10', '20', '30', '50']"
          @change="onShowSizeChange" />
      </div>
      <!-- <Pagination 
              v-model="pagination.current"
              :total="pagination.totalCount"
              show-size-changer
              :page-size="pagination.pageSize"
              @onShowSizeChange="onShowSizeChange"
              ></Pagination> -->
    </div>
    <a-modal :title="title[type]" v-model="categoryVisible" width="60%" @cancel="cancel">
      <template slot="footer" v-if="type == 0">
        <a-button key="back" @click="cancel"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="preservation1"> 保存 </a-button>
      </template>
      <template slot="footer" v-if="type == 1">
        <a-button key="back" @click="cancel"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="preservation2"> 保存 </a-button>
      </template>
      <template slot="footer" v-if="type == 2">
        <a-button key="back" @click="cancel"> 取消 </a-button>
      </template>
      <a-form-model :model="formList" class="formContainer" ref="formListRef">
        <div class="title">
          <span>品类信息</span>
        </div>
        <div class="bottom">
          <a-row>
            <a-col :span="12">
              <a-form-model-item v-if="type == 0" label="所属公司" prop="companyId" class="model_span"
                :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :rules="{
                  required: true,
                  message: '请选择所属公司',
                  trigger: 'change',
                }">
                <a-select allowClear placeholder="请选择所属公司" v-model="formList.companyId" @change="handlecompanyplan">
                  <a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item v-if="type != 0" label="公司名称" prop="companyId" class="model_span"
                :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :rules="{
                  required: true,
                  message: '请选择公司名称',
                  trigger: 'change',
                }">
                <a-select v-if="type == 1" disabled allowClear placeholder="请选择公司名称" v-model="formList.companyId"
                  @change="handlecompanyplan">
                  <a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
                <a-input v-if="type == 2" v-model="formList.deptName" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="品类名称" prop="categoryName" class="model_span" :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }" :rules="{
                  required: true,
                  message: '请输入品类名称',
                  trigger: 'change',
                }">
                <a-input v-model="formList.categoryName" disabled v-if="type == 2" />
                <a-input v-model="formList.categoryName" allowClear placeholder="请输入品类名称" v-else />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="资产总数" prop="categoryNum" class="model_span" :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }">
                <a-input v-model="formList.categorySum" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="库存总数" prop="categorySum" class="model_span" :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }">
                <a-input v-model="formList.categoryNum" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="单位" prop="unit" class="model_span" :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }" :rules="{
                  required: true,
                  message: '请输入单位',
                  trigger: 'change',
                }">
                <a-input v-model="formList.unit" disabled v-if="type == 2" />
                <a-input v-model="formList.unit" allowClear placeholder="请输入单位" v-else />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="创建人" prop="createBy" class="model_span" :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }">
                <a-input v-model="formList.createBy" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item v-if="type != 0" label="创建时间" prop="createTime" class="model_span"
                :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-input v-model="formList.createTime" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item v-if="type != 0" label="维护人" prop="updateBy" class="model_span"
                :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-input v-model="formList.updateBy" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item v-if="type == 2" label="维护时间" prop="updateTime" class="model_span"
                :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-input v-model="formList.updateTime" disabled />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div v-if="type == 2">
          <div class="title">
            <span>关联物品明细</span>
          </div>
          <div class="bottomLsast">
            <a-table :columns="columns1" :data-source="categoryDetail" bordered width="70%" :pagination="false">
              <span slot="index" slot-scope="text, record, index">
                {{ (pagination1.current - 1) * pagination1.pageSize + index + 1 }}
              </span>
              <span slot="state" slot-scope="text">
                <template>
                  <a-tag :color="colors[text]">
                    {{ text ? statusMap[text] : '' }}
                  </a-tag>
                </template>
              </span>
            </a-table>
            <!-- <Pagination 
              v-model="pagination1.current"
              :total="pagination1.totalCount"
              show-size-changer
              :page-size="pagination1.pageSize"
              @onShowSizeChange="onShowSizeChange1"
              ></Pagination> -->
          </div>
          <div>
            <a-pagination v-model="pagination1.current" show-size-changer :page-size.sync="pagination1.pageSize"
              :total="pagination1.totalCount" @showSizeChange="onShowSizeChange1"
              :pageSizeOptions="['10', '20', '30', '50']" @change="onShowSizeChange1" />
          </div>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { limitCompany } from '@/utils/limitCompany'
import { get_dict } from '@/utils/unit_axios'
import { statusMap } from '@/api/activiti'
import { tree_all } from '@/api/purchase'
import Pagination from '@/components/pagination/index.vue'
import { getCategoryList, saveCategory, editCategory, getCategoryDetil } from '@/api/question'
import { get_category_xlsx } from '@/api/assetmenag'
import { downLoadXlxs2 } from '@/utils/index'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      statusMap: '',
      timeout: null,
      row: {
        id: '',
        companyId: '',
      },
      show: false,
      title: ['品类清单-新增', '品类清单-编辑', '品类清单-详情'],
      form: {},
      type: 0,
      pagination: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      // pagination:{ //分页数据
      //      current : 1,
      //      pageSize: 10,
      //      totalCount: 0
      // },
      pagination1: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      scroll_y: 150,
      categoryDetail: [],
      categoryVisible: false,
      formList: {
        companyId: '',
        deptName: '',
        categoryName: '',
        createTime: '',
        categoryNum: 0,
        unit: '',
        createBy: this.$store.getters.userInfo.userName,
        categorySum: 0,
        updateBy: '',
        updateTime: '',
      },
      categoryList: [],
      //公司
      companyList: [],
      categoryName: '',
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          scopedSlots: {
            customRender: 'index',
          },
          width: 70,
          ellipsis: true,
        },
        {
          title: '公司',
          dataIndex: 'deptName',
          key: 'deptName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '品类名称',
          dataIndex: 'categoryName',
          key: 'categoryName',
          width: 150,
          ellipsis: true,
        },
        {
          title: '资产总数',
          dataIndex: 'categorySum',
          key: 'categorySum',
          width: 80,
          ellipsis: true,
        },
        {
          title: '库存数量',
          dataIndex: 'categoryNum',
          key: 'categoryNum',
          width: 80,
          ellipsis: true,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          key: 'unit',
          width: 100,
          ellipsis: true,
        },
        {
          title: '创建人',
          dataIndex: 'createBy',
          key: 'createBy',
          width: 150,
          ellipsis: true,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: '维护人',
          dataIndex: 'updateBy',
          key: 'updateBy',
          width: 150,
          ellipsis: true,
        },
        {
          title: '维护时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action',
          },

          width: 100,
        },
      ],
      columns1: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          scopedSlots: {
            customRender: 'index',
          },
          width: 70,
          ellipsis: true,
        },
        {
          title: '公司部门',
          dataIndex: 'deptName',
          key: 'deptName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '资产类别',
          dataIndex: 'assetTypeName',
          key: 'assetTypeName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '物品编号',
          dataIndex: 'assetSn',
          key: 'assetSn',
          width: 120,
          ellipsis: true,
        },
        {
          title: '物品名称',
          dataIndex: 'name',
          key: 'name',
          width: 120,
          ellipsis: true,
        },
        {
          title: '规格型号',
          dataIndex: 'model',
          key: 'model',
          width: 180,
          ellipsis: true,
        },
        {
          title: '物品状态',
          dataIndex: 'state',
          key: 'state',
          scopedSlots: {
            customRender: 'state',
          },
          width: 150,
          ellipsis: true,
        },
      ],
    }
  },
  created() {
    //获取品类列表
    this.getList()
    //获取公司
    limitCompany().then((res) => {
      res.forEach((item) => {
        if (item.deptId) {
          this.companyList.push(item)
        }
      })
    })

    // tree_all().then(res => {
    // 	if(res.code == 200) {
    // 		this.companyList = res.data[0]
    // 	}
    // })
  },
  mounted() {

  },
  methods: {
    //导出
    exp() {
      downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/daily/category/download',
        { companyId: this.form.companyId, categoryName: this.form.categoryName })
    },
    //编辑保存
    preservation2() {
      this.$refs.formListRef.validate((valid) => {
        if (valid) {
          editCategory(this.formList).then((res) => {
            if (res.code == 200) {
              this.getList()
              this.categoryVisible = false
              this.$refs.formListRef.resetFields()
              this.formList = {}
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 选择公司
    handlecompanyplan(e) {
      this.companyList.forEach((item) => {
        if (item.deptId == e) {
          this.formList.deptName = item.title
        }
      })
    },
    //新增品类
    preservation1() {
      this.$refs.formListRef.validate((valid) => {
        if (valid) {
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            saveCategory(this.formList).then((res) => {
              if (res.code == 200) {
                this.categoryVisible = false
                this.$refs.formListRef.resetFields()
                this.formList = {}
                this.$emit('getData')
                this.getList()
              } else {
                this.$message.error(res.msg)
              }
            })
          }, 1000)
        }
      })
    },
    //分页
    onShowSizeChange(current, pageSize) {
      console.log(current, pageSize)
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      //改变完 重新渲染数据
      this.getList()
    },
    //分页
    onShowSizeChange1(current, pageSize) {
      console.log(current, pageSize)
      this.pagination1.current = current
      this.pagination1.pageSize = pageSize
      //改变完 重新渲染数据
      this.getDetail()
    },
    // 	 onShowSizeChange2(current, pageSize) {
    //   this.pagination1.current = current
    //   this.pagination1.pageSize = pageSize;
    //  this.getDetail()

    //   },
    //   获取列表数据
    getList() {
      this.show = !this.show
      getCategoryList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        companyId: this.form.companyId,
        categoryName: this.form.categoryName,
      }).then((res) => {
        if (res.code == 200) {
          this.show = !this.show
          this.categoryList = res.data.list
          this.pagination.totalCount = res.data.totalCount;
          this.$nextTick(() => {
            var max_h = $('#content_main_center_scroll2').height()
            console.log(max_h,'max_hmax_hmax_hmax_h')
            setTimeout(() => {
              this.scroll_y = max_h - $('.ant-table-header').height()-35
            }, 1000)
          })
          console.log(this.categoryList, 'this.categoryList')
        } else {
          this.$message.error(res.msg)
        }
        console.log(res, 'res=========================')
      })
    },
    //重置事件
    reset() {
      this.form = {}
      this.getList()
    },
    //查询事件
    searchData() {
      ; (this.pagination.current = 1), (this.pagination.pageSize = 10), this.getList()
    },
    //下拉框搜索
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 新增品类事件
    addCaterage() {
      this.formList = {}
      this.formList.categoryNum = 0
      this.formList.createBy = this.$store.getters.userInfo.userName
      this.formList.categorySum = 0
      this.categoryVisible = true
      this.type = 0
    },
    // 编辑
    edit(record) {
      // this.formList = {}
      console.log(record, 'record===================')
      this.formList = JSON.parse(JSON.stringify(record))
      // this.formList = record
      this.categoryVisible = true
      this.type = 1
    },
    getDetail() {
      getCategoryDetil({
        pageIndex: this.pagination1.current,
        pageSize: this.pagination1.pageSize,
        id: this.row.id,
        companyId: this.row.companyId,
      }).then((res) => {
        if (res.code == 200) {
          this.categoryDetail = res.data.list
          this.pagination1.totalCount = res.data.totalCount
        }
      })
    },
    //详情
    details(record) {
      // console.log()
      get_dict('goodStatus', (res) => {
        // for (let i in res) {
        // 	if (res[i] == '退货') {
        // 		delete res[i]
        // 	}
        // }
        this.statusMap = res
      })
      this.categoryList = {}
      this.formList = record
      this.row.id = record.id
      this.row.companyId = record.companyId
        ; (this.pagination1.current = 1), (this.pagination1.pageSize = 10), this.getDetail()
      console.log(this.pagination1.current, this.pagination1.pageSize, '11111111111111111111111111111')
      // this.categoryDetail = {}

      this.categoryVisible = true
      this.type = 2
    },
    //取消事件
    cancel() {
      if (this.type == 0) {
        this.formList = {}
        this.$refs.formListRef.resetFields()
      }
      if (this.type == 1) {
        this.$refs.formListRef.resetFields()
      }
      // if(this.type==2) {
      // 	this.pagination1.current = 1
      //     this.pagination1.pageSize = 10

      // }
      //  this.pagination1.current = 1,
      // this.pagination1.pageSize = 10,

      this.categoryVisible = false
    },
  },
}
</script>

<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  float: left;

  .containerSerch {
    width: 100%;
    height: 50px;
    float: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .content_main_center {
    width: 100%;
    height: calc(100% - 50px);
    float: left;
  }
}


.title {
  font-size: 16px;
  margin: 5px;
  padding: 2px 10px;
}

.bottomLsast {
  background-color: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 15px;
}

.bottom {
  background-color: #fff;
  margin: 10px;
  padding: 10px;
  padding-top: 30px;
  border-radius: 15px;
}

.content_main_center {
  margin-top: 10px;
}

.margin_self {
  margin-right: 10px;
}

.pageBottom {
  margin-top: 10px;
  display: flex;
  flex-direction: row-reverse;
}

.model_span {
  margin-top: -10px;
}
</style>